import { Controller, useFieldArray } from 'react-hook-form';
import React from 'react';
import Input from 'src/components/Input/Input';
import { InvalidMessage } from 'src/components/Input/InvalidMessage';
import { InputInfoToolTip } from 'src/components/Input/InputInfoToolTip';
import { Button } from 'src/components/ui/button';
import PlusGreenIcon from 'src/assets/img/plus-green-icon.svg';
import TrashGreyIcon from 'src/assets/img/trash-grey-icon.svg';

export const ZendeskHelpCenterUrlList = ({
  control,
  clearErrors = (..._args: any[]) => {},
  name,
  title,
  itemLabel,
  addLabel,
}: {
  control?: any;
  clearErrors?: (...args: any[]) => void;
  name: 'source_links' | 'excluded_articles';
  title?: string;
  itemLabel: string;
  addLabel: string;
}) => {
  const { fields, append, remove } = useFieldArray({ control, name });

  return (
    <div className={'flex flex-col w-full gap-2'}>
      {title && (
        <div className={'flex items-center gap-1'}>
          <p className={'text-sm font-bold text-grey_750'}>{title}</p>
          <InputInfoToolTip
            infoToolTip={{
              side: 'right',
              description: <>Only article links (with //**/**/articles/**) are supported here</>,
            }}
          />
        </div>
      )}
      {fields.map((item, index) => (
        <Controller
          key={item.id}
          control={control}
          name={`${name}.${index}`}
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <div className={'flex flex-col w-full gap-1'}>
              <div className={'flex w-full items-start gap-2'}>
                <div className={'flex-1 min-w-0'}>
                  <Input
                    type={'text'}
                    placeholder={'https://www'}
                    invalidMessage={error?.type === 'matches' ? '' : error?.message}
                    value={value}
                    isValid={!error?.message}
                    onChange={onChange}
                    onFocus={() => {
                      clearErrors(`${name}.${index}`);
                    }}
                  />
                </div>
                <Button
                  type={'button'}
                  variant={'ghost-grey'}
                  size={'icon'}
                  aria-label={`Remove ${itemLabel} ${index + 1}`}
                  onClick={() => remove(index)}
                  className={'h-auto w-auto p-2.5'}
                >
                  <img src={TrashGreyIcon} alt={''} width={16} height={16} />
                </Button>
              </div>
              {error?.type === 'matches' && (
                <InvalidMessage
                  className={'!py-2 text-center'}
                  invalidMessage={error?.message}
                  isPassword={false}
                />
              )}
            </div>
          )}
        />
      ))}
      <Button
        type={'button'}
        variant={'ghost-accent'}
        onClick={() => append('')}
        className={'self-start px-4 py-2 h-auto'}
      >
        {addLabel}
        <img src={PlusGreenIcon} alt={''} width={16} height={16} />
      </Button>
    </div>
  );
};
